import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme.js';
import Logo from '../../assets/logo.png';

export default class CompanyLogo extends Component {
  render() {
    return (
      <Link to="/">
        <div className={css(styles.logo)}>
          <img src={Logo} className={css(styles.image)} />
        </div>
      </Link>
    );
  }
}

const styles = StyleSheet.create({
  logo: {
    display: 'flex',
    textAlign: 'center',
    flex: 1
  },
  image: {
    width: 113,
    height: 54,
    transition: "opacity 150ms ease-in-out",
    ":hover": {
      opacity: 0.5,
    },
  },
})



// WEBPACK FOOTER //
// ./src/components/CompanyLogo/index.js